module.exports = "/_next/static/images/attachment-ad3b0200e47a29665596424d325b37d8.svg";